import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

interface SubjectSectionProps {
  subjectTemplate: string;
  importance: {
    high: { label: string };
    medium: { label: string };
    low: { label: string };
  };
  isDirty?: boolean;
  onSubjectTemplateChange: (value: string) => void;
  onLabelChange: (key: 'high' | 'medium' | 'low', value: string) => void;
}

const SubjectSection: React.FC<SubjectSectionProps> = ({
  subjectTemplate,
  importance,
  onSubjectTemplateChange,
  onLabelChange
}) => {
  const generateSubjectPreview = (type: 'high' | 'medium' | 'low') => {
    const label = importance[type].label;
    return `[${label}] ${subjectTemplate}`;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>メール件名編集</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 px-4">
        {/* 件名テンプレート設定 */}
        <div>
          <Input
            value={subjectTemplate}
            onChange={(e) => onSubjectTemplateChange(e.target.value)}
            placeholder="WEBサイトからのお問い合わせ"
            className="mb-2"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* 低重要度 */}
          <div>
            <label className="block text-sm font-medium mb-2">低</label>
            <Input
              value={importance.low.label}
              onChange={(e) => onLabelChange('low', e.target.value)}
              placeholder="低"
            />
            <p className="mt-2 text-sm text-gray-500">
              {generateSubjectPreview('low')}
            </p>
          </div>

          {/* 中重要度 */}
          <div>
            <label className="block text-sm font-medium mb-2">中</label>
            <Input
              value={importance.medium.label}
              onChange={(e) => onLabelChange('medium', e.target.value)}
              placeholder="通常"
            />
            <p className="mt-2 text-sm text-gray-500">
              {generateSubjectPreview('medium')}
            </p>
          </div>

          {/* 高重要度 */}
          <div>
            <label className="block text-sm font-medium mb-2">高</label>
            <Input
              value={importance.high.label}
              onChange={(e) => onLabelChange('high', e.target.value)}
              placeholder="重要"
            />
            <p className="mt-2 text-sm text-gray-500">
              {generateSubjectPreview('high')}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubjectSection;
